module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Sense Island -感覚の島- 暗闇の美術島 2021","short_name":"Sense Island","start_url":"/","display":"standalone","orientation":"any","background_color":"#000","theme_color":"#000","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8d8e31ec5f3c5b0b7678300be300d040"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-XVC61NVC4H"],"pluginConfig":{"head":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/Users/sumisonic/Repositories/gitlab.rzm.co.jp/sumito-rzm/senseisland_2021/src/layout/Layout.tsx"},
    },{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/Users/sumisonic/Repositories/gitlab.rzm.co.jp/sumito-rzm/senseisland_2021/gatsby/locales","languages":["ja","en"],"defaultLanguage":"ja","redirect":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-ts-config/gatsby-browser.js'),
      options: {"plugins":[],"configDir":"gatsby","projectRoot":"/Users/sumisonic/Repositories/gitlab.rzm.co.jp/sumito-rzm/senseisland_2021"},
    }]
